exports.install = function (Vue, options) {
	//发送手机验证码
	Vue.prototype.send = function(value)
	{
		return this.axiospost("/api/sms/send",value)
		.then((res)=>{
			return res;
		});
	};
	//手机验证码检测
	Vue.prototype.smscheck = function(value)
	{
		return this.axiospost("/api/sms/check",value)
		.then((response)=>{
			return response;
		});
	};
}